import * as FileSaver from 'file-saver';
import * as React from 'react';
import toCsv, { Columns } from './lib/csv';

export type PrefixSuffix = boolean | string | number

export type CsvMapping<TData> = { [ field : string ] : keyof TData | ( ( x : TData ) => any ) }

export interface ICsvDownloadProps<TData> {
  bom: boolean
  columns: Columns
  data: object[]
  filename: string
  noHeader?: boolean
  prefix?: PrefixSuffix
  separator?: string
  mapping : CsvMapping<TData>,
  text?: string
  suffix?: PrefixSuffix
  wrapColumnChar?: string
}

type DefaultProps = 'bom' | 'columns' | 'noHeader' | 'separator'

export class CsvDownloader<TData> extends React.Component<ICsvDownloadProps<TData>> {
  public static defaultProps: Pick<ICsvDownloadProps<any>, DefaultProps> = {
    bom: true,
    columns: false,
    noHeader: false,
    separator: ',',
  }

  public handleClick = () => {
    const { suffix, prefix, bom, data, mapping, separator, noHeader, wrapColumnChar } = this.props

    const columns = Object.keys( mapping )
    const transform = columns.map(
      name => {
        const m = mapping[ name ];
        return x => String( typeof m === 'function' ? m(x) : x[m] );
      })

    const table = data.map( x => transform.map( t => t( x ) ));

    const csv = toCsv(columns, table, separator, noHeader, '"')

    const bomCode = bom ? '\ufeff' : ''
    let { filename } = this.props

    if (filename.indexOf('.csv') === -1) {
      filename += '.csv'
    }

    if (suffix) {
      filename = typeof suffix === 'string' || typeof suffix === 'number'
        ? filename.replace('.csv', `_${suffix}.csv`)
        : filename.replace('.csv', `_${(new Date()).getTime()}.csv`)
    }

    if (prefix) {
      filename = typeof prefix === 'string' || typeof prefix === 'number'
        ? `${prefix}_${filename}`
        : `${(new Date()).getTime()}_${filename}`
    }

    const blob = new Blob([`${bomCode}${csv}`], { type: 'text/csv;charset=utf-8' })
    FileSaver.saveAs(blob, filename)
  }

  public render() {
    const { children, text } = this.props

    if (typeof children === 'undefined') {
      return this.props.data ?
        <button onClick={this.handleClick} type="button" aria-label="Download">
          {text ? text : 'Download'}
        </button>
      : <span/>
    }

    return this.props.data ?
      <div onClick={this.handleClick} onKeyPress={this.handleClick} role="button" tabIndex={0} aria-label="Download">
        {children}
      </div>
    : <span/>
  }
}
